import a from "./auth.module.css";

export default function AuthSteps({ current, total, labels = [] }) {
  const safeLabels =
    labels.length >= total
      ? labels.slice(0, total)
      : Array.from({ length: total }, (_, i) => String(i + 1));

  return (
    <div className={a.steps} aria-label={`Шаг ${current} из ${total}`}>
      <p className={a.stepsMeta}>
        Шаг <strong>{current}</strong> из {total}
      </p>

      <div className={a.stepsBar} aria-hidden>
        {safeLabels.map((label, i) => {
          const n = i + 1;
          const done = n < current;
          const active = n === current;
          return (
            <div
              key={label}
              className={[
                a.stepSeg,
                done ? a.stepSegDone : "",
                active ? a.stepSegActive : "",
              ]
                .filter(Boolean)
                .join(" ")}
              title={label}
            />
          );
        })}
      </div>

      <div className={a.stepsLabels} aria-hidden>
        {safeLabels.map((label, i) => {
          const n = i + 1;
          const done = n < current;
          const active = n === current;
          return (
            <span
              key={label}
              className={[
                a.stepLabel,
                done ? a.stepLabelDone : "",
                active ? a.stepLabelActive : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              {label}
            </span>
          );
        })}
      </div>
    </div>
  );
}
